import Vue from "vue"
import Router from "vue-router"

import { getToken } from "@/utils/auth"

Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: "/",
            redirect: "/login"
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/login")
        },

        {
            path: "pages",
            component: () => import("@/views/routerview"),
            redirect: "/pages/home",
            meta: {
                title: "gameManagementSon.gameSettings",
                // roles: ['admin'] // or you can only set roles in sub nav
                affix: true
            },
            children: [
                {
                    path: "/home",
                    name: "home",
                    component: () => import("@/views/home")
                },
                {
                    path: "/info",
                    name: "info",
                    component: () => import("@/views/info")
                },
                {
                    path: "/payment",
                    name: "payment",
                    component: () => import("@/views/payment")
                },
                {
                    path: "/rechargeStats",
                    name: "rechargeStats",
                    component: () => import("@/views/rechargeStats")
                },

                {
                    path: "/withdrawal",
                    name: "withdrawal",
                    component: () => import("@/views/withdrawal")
                },

                {
                    path: "/cashflow",
                    name: "cashflow",
                    component: () => import("@/views/cashflow")
                },
                {
                    path: "/operationRcord",
                    name: "operationRcord",
                    component: () => import("@/views/operationRcord")
                },

                {
                    path: "/RechargeIndex",
                    component: () => import("@/views/RechargeManage/index"),
                    name: "RechargeIndex"
                },
                {
                    path: "/RechargeStats",
                    component: () => import("@/views/RechargeManage/RechargeStats"),
                    name: "RechargeStats"
                },

                {
                    path: "/RechargeList",
                    component: () => import("@/views/RechargeManage/RechargeList"),
                    name: "RechargeList"
                },
                {
                    path: "/RechargeTest",
                    name: "RechargeTest",
                    component: () => import("@/views/RechargeManage/RechargeTest")
                },

                {
                    path: "/WithdrawIndex",
                    component: () => import("@/views/WithdrawManage/index"),
                    name: "WithdrawIndex"
                },
                {
                    path: "/WithdrawStats",
                    component: () => import("@/views/WithdrawManage/WithdrawStats"),
                    name: "WithdrawStats"
                },

                {
                    path: "/WithdrawList",
                    component: () => import("@/views/WithdrawManage/WithdrawList"),
                    name: "WithdrawList"
                },
                {
                    path: "/WithdrawTest",
                    name: "WithdrawTest",
                    component: () => import("@/views/WithdrawManage/WithdrawTest")
                }
            ]
        }
    ]
})

export default router

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    console.log(getToken())
    let white_list = ["/login"]
    if (white_list.indexOf(to.path) >= 0 || getToken()) {
        next()
    } else {
        next("/login")
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js